/**
 * The canonical V2 message channel keys.
 *
 * Kept in its own dependency-free module (no `effect`/`Schema` import) so the
 * list and the helpers built from it (label map, type guard) can be consumed by
 * environments — e.g. the support app's jest unit tests — that can't load
 * `effect` at runtime. {@link ./message} builds the `MessageChannel` schema from
 * this array.
 */
export const MESSAGE_CHANNELS = [
  "gmail",
  "outlook",
  "customEmail",
  "redoChat",
  "facebookDm",
  "facebookComments",
  "instagramDm",
  "instagramComments",
  "sms",
  "voice",
  "attentive",
  "postscript",
  "tiktok",
  "contactForm",
  "internalNote",
  "mobileMessage",
] as const;
